// reducers/notificationReducer.js
import {
  FETCH_NOTIFICATIONS_REQUEST,
  FETCH_NOTIFICATIONS_SUCCESS,
  FETCH_NOTIFICATIONS_FAILURE,
  MARK_NOTIFICATION_READ_REQUEST,
  MARK_NOTIFICATION_READ_SUCCESS,
  MARK_NOTIFICATION_READ_FAILURE,
  MARK_ALL_NOTIFICATIONS_READ_REQUEST,
  MARK_ALL_NOTIFICATIONS_READ_SUCCESS,
  MARK_ALL_NOTIFICATIONS_READ_FAILURE,
  DELETE_NOTIFICATION_REQUEST,
  DELETE_NOTIFICATION_SUCCESS,
  DELETE_NOTIFICATION_FAILURE,
  GET_NOTIFICATION_STATS_REQUEST,
  GET_NOTIFICATION_STATS_SUCCESS,
  GET_NOTIFICATION_STATS_FAILURE,
  ADD_NEW_NOTIFICATION,
  UPDATE_NOTIFICATION_COUNT,
} from "./notificationActionTypes";

const initialState = {
  loading: false,
  notificationsData: {
    notifications: [],
    currentPage: 1,
    totalPages: 0,
    totalCount: 0,
    unreadCount: 0,
  },
  notificationStats: {
    stats: [],
    totalUnread: 0,
  },
  error: null,
};

const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    // FETCH NOTIFICATIONS
    case FETCH_NOTIFICATIONS_REQUEST:
      return { ...state, loading: true, error: null };
    
  case FETCH_NOTIFICATIONS_SUCCESS:
  if (action.payload.type === "notificationsData") {
    // The API response is the actual data we need
    const responseData = action.payload.data;
    
    return {
      ...state,
      loading: false,
      error: null,
      notificationsData: {
        notifications: responseData.notifications || [],
        currentPage: responseData.currentPage || 1,
        totalPages: responseData.totalPages || 0,
        totalCount: responseData.totalCount || 0,
        unreadCount: responseData.unreadCount || 0,
      },
    };
  }
  return state;
    
    case FETCH_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        notificationsData: initialState.notificationsData,
      };

    // MARK NOTIFICATION AS READ
    case MARK_NOTIFICATION_READ_REQUEST:
      return { ...state, loading: true, error: null };
    
// Also update other cases to handle the API structure
case MARK_NOTIFICATION_READ_SUCCESS:
  if (action.payload.type === "notificationRead") {
    const updatedNotification = action.payload.data.notification;
    
    const updatedNotifications = state.notificationsData.notifications.map(notification =>
      notification._id === updatedNotification._id
        ? { ...notification, isRead: true }
        : notification
    );
    
    return {
      ...state,
      loading: false,
      error: null,
      notificationsData: {
        ...state.notificationsData,
        notifications: updatedNotifications,
        unreadCount: Math.max(0, state.notificationsData.unreadCount - 1),
      },
    };
  }
  return state;
    
    case MARK_NOTIFICATION_READ_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // MARK ALL NOTIFICATIONS AS READ
    case MARK_ALL_NOTIFICATIONS_READ_REQUEST:
      return { ...state, loading: true, error: null };
    
    case MARK_ALL_NOTIFICATIONS_READ_SUCCESS:
      if (action.payload.type === "allNotificationsRead") {
        const updatedNotifications = state.notificationsData.notifications.map(notification =>
          ({ ...notification, isRead: true })
        );
        
        return {
          ...state,
          loading: false,
          error: null,
          notificationsData: {
            ...state.notificationsData,
            notifications: updatedNotifications,
            unreadCount: 0,
          },
        };
      }
      return state;
    
    case MARK_ALL_NOTIFICATIONS_READ_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // DELETE NOTIFICATION
    case DELETE_NOTIFICATION_REQUEST:
      return { ...state, loading: true, error: null };
    
    case DELETE_NOTIFICATION_SUCCESS:
      if (action.payload.type === "notificationDeleted") {
        const deletedNotification = state.notificationsData.notifications.find(
          n => n._id === action.payload.data.notification?._id
        );
        
        const filteredNotifications = state.notificationsData.notifications.filter(
          notification => notification._id !== action.payload.data.notification?._id
        );
        
        const unreadDecrease = deletedNotification && !deletedNotification.isRead ? 1 : 0;
        
        return {
          ...state,
          loading: false,
          error: null,
          notificationsData: {
            ...state.notificationsData,
            notifications: filteredNotifications,
            unreadCount: Math.max(0, state.notificationsData.unreadCount - unreadDecrease),
            totalCount: Math.max(0, state.notificationsData.totalCount - 1),
          },
        };
      }
      return state;
    
    case DELETE_NOTIFICATION_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // GET NOTIFICATION STATS
    case GET_NOTIFICATION_STATS_REQUEST:
      return { ...state, loading: true, error: null };
    
    case GET_NOTIFICATION_STATS_SUCCESS:
      if (action.payload.type === "notificationStats") {
        return {
          ...state,
          loading: false,
          error: null,
          notificationStats: action.payload.data,
        };
      }
      return state;
    
    case GET_NOTIFICATION_STATS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // REAL-TIME NOTIFICATIONS
    case ADD_NEW_NOTIFICATION:
      return {
        ...state,
        notificationsData: {
          ...state.notificationsData,
          notifications: [action.payload, ...state.notificationsData.notifications],
          unreadCount: state.notificationsData.unreadCount + 1,
          totalCount: state.notificationsData.totalCount + 1,
        },
      };

    case UPDATE_NOTIFICATION_COUNT:
      return {
        ...state,
        notificationsData: {
          ...state.notificationsData,
          unreadCount: action.payload,
        },
      };

    default:
      return state;
  }
};

export default notificationReducer;